// eslint-disable-next-line import/prefer-default-export
export enum BillingStatus {
  ALL = 'ALL',
  PRE_INVOICE = 'PRE_INVOICE',
  BILLED = 'BILLED',
  RECEIVED = 'RECEIVED',
  DEFAULTING = 'DEFAULTING',
  TO_RECEIVE = 'TO_RECEIVE',
  NOT_BILLED = 'NOT_BILLED',
  TO_BILL = 'TO_BILL',
  WITHIN_DEADLINE = 'WITHIN_DEADLINE',
  DISCOUNTED = 'DISCOUNTED',
  INVOICE_ZERO_VALUE='INVOICE_ZERO_VALUE',
  INVOICE_HAS_VALUE='INVOICE_HAS_VALUE',
  PRE_INVOICE_WITH_EXTERNAL_PAYMENT_ERROR='PRE_INVOICE_WITH_EXTERNAL_PAYMENT_ERROR',
  PRE_INVOICE_WITH_EXTERNAL_PAYMENT_INTEGRATION_ERROR='PRE_INVOICE_WITH_EXTERNAL_PAYMENT_INTEGRATION_ERROR',
}
